exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blocContainer[data-v-f5e29e6e]{padding:20px}.blocContainer .container_title[data-v-f5e29e6e]{text-align:left;display:flex;align-items:center}.blocContainer .container_title .title[data-v-f5e29e6e]{font-weight:700;font-size:1.3em}.blocContainer .container_title .b-icon.bi[data-v-f5e29e6e]{color:#635bff;height:25px;width:25px;margin-right:10px}.blocContainer .content[data-v-f5e29e6e]{color:#fff;font-size:1em;text-align:left;font:normal normal normal 1.2em Segoe UI;letter-spacing:0;opacity:1}", ""]);

// exports
